import React from 'react'
import "./projects.css"

import IMG1 from "../../assets/projects/aiblog.png";
import IMG2 from "../../assets/projects/stt_tts_sts.png";
import IMG3 from "../../assets/projects/watering.png"
import IMG4 from "../../assets/projects/portfolio.png"
// import IMG5 from "../../assets/projects/alo_do_me_to.png"
import IMG6 from "../../assets/projects/super-voice-assistant.png"


const projects = [
  {
    id: 1,
    image: IMG4,
    title: "My Personal Website | HTML, CSS, JS, ReactJS.",
    github: "https://github.com/hounfodji",
    demo: "https://hospice-dev.vercel.app/",
  },
  {
    id: 2,
    image: IMG3,
    title: "Smart Watering Plants | Flutter, Firebase.",
    github: "https://github.com/hounfodji/watering_plants",
    demo: "https://youtu.be/U8s6DU4g6RQ",
  },
  {
    id: 3,
    image: IMG1,
    title: "AI Blog App  |  Django, ChatGPT, assemblyai.",
    github: "https://github.com/hounfodji/ai_blog_generator",
    demo: "https://www.youtube.com/watch?v=Z7Jk_15DSnY",
  },
  {
    id: 4,
    image: IMG2,
    title: "SpeechtoText_TtoS_StoS | Python.",
    github: "https://github.com/hounfodji/speech_to_text_text_to_speech_speech_to_speech",
    demo: "https://youtu.be/IjiFFTSkWaI",
  },

  // {
  //   id: 5,
  //   image: IMG5,
  //   title: "alɔ Do mɛ tɔ Assistant Vocal Multifonctionnel | Flutter, Gemini AI.",
  //   github: "https://github.com/hounfodji/AIDA",
  //   demo: "https://lablab.ai/event/benin-multimodal-ai-hackathon/aida/al%C9%94-do-m%C9%9B-t%C9%94-assistant-vocal-multifonctionnel",
  // },

  {
    id: 6,
    image: IMG6,
    title: "Super-Voice-Assistant | React, Django, DRF,  Gemini AI.",
    github: "https://github.com/hounfodji/Super-Voice-Assistant",
    demo: "https://github.com/hounfodji/Super-Voice-Assistant",
  },


  

  // {
  //   id: 4,
  //   image: IMG4,
  //   title: "Somarven- Full-stack Group project", 
  //   github: "https://github.com/hounfodji/react-noteApp-frontend",
  //   demo: "https://somarven.netlify.app/",
  // },

  // {
  //   id: 5,
  //   image: IMG5,
  //   title: "Space Travelers Hub- React-Redux Group project",
  //   github: "https://github.com/Somdotta07/space-travelers-hub",
  //   demo: "https://cranky-cray-0feacf.netlify.app/",
  // },
  // {
  //   id: 6,
  //   image: IMG6,
  //   title: "Awesome Books - displays, add books",
  //   github: "https://github.com/Somdotta07/Awesome_Books",
  //   demo: "https://somdotta07.github.io/Awesome_Books/",
  // },
];
const Projects = () => {
  return (
    <section id="projects">
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>
      <div className="container project_container">
        {projects.map(({ id, image, title, github, demo }) => {
          return (
            <article key={id} className="project_item">
              <div className="project_item-image">
                <img src={image} alt={title} />
              </div>
              <h3>{title}</h3>
              <div className="project-item-cta">
                <a href={github} className="btn" target="_blank" rel="noreferrer">
                  Github
                </a>
                <a
                  href={demo}
                  className="btn btn-primary"
                  target="_blank"
                  rel="noreferrer"
                >
                  Live Demo
                </a>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
};


export default Projects
